<div class="filter-vals">
  <form [formGroup]="form" (ngSubmit)="showHideColumns()">
    <ng-container formArrayName="headers" *ngFor="let val of headerNames; let i = index">
      <div class="filter-val">
        <label
          ><input
            class="chk-box"
            type="checkbox"
            [value]="val.name"
            [checked]="!val.hide"
            (change)="onCheckboxChange($event)"
          /><span class="tmp">{{ val.label || val.Label }}</span></label
        >
      </div>
    </ng-container>
    <div class="hr-divider"></div>
    <div class="ctrls-input-box">
      <button class="btn btn-default cst-btn cst-apply" (click)="showAllColumns()">Show All</button>
      <button class="btn btn-default cst-btn cst-clear" (click)="showHideColumns()">Done</button>
    </div>
  </form>
</div>
